import { render, staticRenderFns } from "./editPaPayrollIndex.vue?vue&type=template&id=3153f00a&"
import script from "./editPaPayrollIndex.vue?vue&type=script&lang=js&"
export * from "./editPaPayrollIndex.vue?vue&type=script&lang=js&"
import style0 from "./editPaPayrollIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports